import { useTranslate } from '../../lib'
import { InputNesting, TextareaNesting } from '../common/Inputs/Input'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ButtonYesNo from '../common/ButtonYesNo'
import { useEffect } from 'react'

export default function WizardStep1({ formData, setFormData, refs, listLanguage, fetchVoice }) {
  const { t } = useTranslate();

  return (
    <div className="wizard-step">
      <h2 className="mb-4" style={{ color: '#0B5FA3', fontSize: 20 }}>
        {t('menu.genai.basicInformation')}
      </h2>

      <div id="con-data-main" className='flex w-full'>
        <div className='flex flex-col flex-1'>
          <InputNesting
            ref={refs.name_ref}
            defaultValue={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            id="name"
            title={t('common.name')}
            tooltip={true}
            tooltipText={t('alerts.charactersNameTooltip')}
            placeholder={t('menu.genai.typeNewProject')}
          />

          <TextareaNesting
            ref={refs.description_ref}
            id="description"
            title={t('common.description')}
            row={3}
            defaultValue={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}            
            containerClass="mt-2"
            placeholder={t('menu.genai.detailedDescriptionPlaceholder')}
          />

          <div className="inputs" style={{ marginTop: 20 }}>
            <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
              <div className="flex items-center">
                <span>{t('menu.genai.botType')}:</span>
                <img id="bottype-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-5 cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#bottype-tp" content={t('menu.genai.inboundOuntboundTooltip')} place="top" />
              </div>
              <div className="ml-2 list_bot_type d-flex flex-row align-items-center">
                <ButtonYesNo
                  onClick={() => setFormData({ ...formData, channel: formData.channel === "voice" ? "chat" : "voice" })}
                  width={170}
                  state={formData.channel === "chat" ? false : true}
                  height={30}
                  Yes={t('menu.voiceBot')}
                  No={t('menu.chatBot')}
                />
              </div>
            </div>
          </div>

          <div className="inputs" style={{ marginTop: 20 }}>
            <div className="input" style={{ maxWidth: 200 }}>
              <div className="d-flex flex-row align-items-center w-100">
                <span>{t('common.language')}:</span>
                <img id="language" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#language" textColor="#ffffff"
                  html={t('menu.genai.languageForProjectTooltip')} place="top" />
                <select ref={refs.language} id="language" 
                  defaultValue={formData.language}
                  onChange={(e) => { 
                    setFormData({ ...formData, language: e.target.value })
                    fetchVoice()
                  }} 
                  className='select ml-3 select-nesting input-data'
                  style={{ flexGrow: '2' }}
                  >
                  {listLanguage.map((item, index) => (<option key={index} value={item.value}>{item.name}</option>))}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="inputs flex-1 ml-3" style={{ paddingRight: 15 }} id="image">
          <div className="input">
            <div className="flex items-center">
              <span>{t('menu.genai.projectLogo')}</span>
              <img id="image-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
              <Tooltip openOnClick={true} anchorSelect="#image-tp" content={t('menu.genai.projectLogoTooltip')} place="top" />
            </div>
            <label className="custom-file">
              <input
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    image: e.target.files[0],
                    imageName: e.target.files[0]?.name || "Upload"
                  });
                }}
                type="file"
                accept="image/png, .jpeg, .jpg"
              />
              {formData.imageName}
            </label>

            <div>
              {formData.image && <img src={URL.createObjectURL(formData.image)} alt='' style={{ width: "100%", height: 120, objectFit: "contain" }} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
